import { Bell, Contact, Scissors, Store, Timer, Users } from 'lucide-react';
import { VERTICAL_COMPARISON } from '../comparisonMatrix';
import type { LandingConfig } from '../types';

export const barbersConfig: LandingConfig = {
  slug: 'barbers',
  namespace: 'landing-barbers',
  analyticsId: 'for-barbers',
  canonicalPath: '/for-barbers',
  ogImagePath: '/images/og-barbers.jpg',
  heroImage: '/images/hero-barbers',
  // Order matches landing-barbers:features.items[]
  featureIcons: [Store, Bell, Users, Scissors, Contact, Timer],
  comparison: VERTICAL_COMPARISON,
};
